module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/discover/MFestival.jpg?1b5891b1fcf2872f6157ea11f31be468";